// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingAnimation_healthgenom_container__2-NoE","logo":"LoadingAnimation_healthgenom_logo__3PhoQ","text":"LoadingAnimation_healthgenom_text__3SV8Z"};